
// @ts-nocheck
import locale_en_46json_d82de72f from "#nuxt-i18n/d82de72f";
import locale_fr_46json_c72c6d66 from "#nuxt-i18n/c72c6d66";
import locale_es_46json_b44cb1e4 from "#nuxt-i18n/b44cb1e4";
import locale_zh_46json_cb038552 from "#nuxt-i18n/cb038552";
import locale_hi_46json_bd936576 from "#nuxt-i18n/bd936576";
import locale_de_46json_28978ed6 from "#nuxt-i18n/28978ed6";
import locale_nl_46json_aa944922 from "#nuxt-i18n/aa944922";
import locale_pt_46json_7f89e2c3 from "#nuxt-i18n/7f89e2c3";
import locale_it_46json_3229c477 from "#nuxt-i18n/3229c477";
import locale_ja_46json_68ebd95d from "#nuxt-i18n/68ebd95d";
import locale_ko_46json_24cd6f7f from "#nuxt-i18n/24cd6f7f";

export const localeCodes =  [
  "en",
  "fr",
  "es",
  "zh",
  "hi",
  "de",
  "nl",
  "pt",
  "it",
  "ja",
  "ko"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_d82de72f",
      load: () => Promise.resolve(locale_en_46json_d82de72f),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_c72c6d66",
      load: () => Promise.resolve(locale_fr_46json_c72c6d66),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_b44cb1e4",
      load: () => Promise.resolve(locale_es_46json_b44cb1e4),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_cb038552",
      load: () => Promise.resolve(locale_zh_46json_cb038552),
      cache: true
    }
  ],
  hi: [
    {
      key: "locale_hi_46json_bd936576",
      load: () => Promise.resolve(locale_hi_46json_bd936576),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_28978ed6",
      load: () => Promise.resolve(locale_de_46json_28978ed6),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_aa944922",
      load: () => Promise.resolve(locale_nl_46json_aa944922),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_7f89e2c3",
      load: () => Promise.resolve(locale_pt_46json_7f89e2c3),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_3229c477",
      load: () => Promise.resolve(locale_it_46json_3229c477),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_68ebd95d",
      load: () => Promise.resolve(locale_ja_46json_68ebd95d),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_24cd6f7f",
      load: () => Promise.resolve(locale_ko_46json_24cd6f7f),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      region: "United States",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      region: "France",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      region: "España",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      name: "中文",
      region: "简体",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/zh.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hi",
      name: "हिन्दी",
      region: "भारत",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/hi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      region: "Deutschland",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      name: "Nederlands",
      region: "Nederland",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      name: "Português",
      region: "Portugal",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/pt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      name: "Italiano",
      region: "Italia",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      name: "日本語",
      region: "日本",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/ja.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      name: "한국어",
      region: "대한민국",
      files: [
        {
          path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/ko.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    region: "United States",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    region: "France",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    region: "España",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    name: "中文",
    region: "简体",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/zh.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hi",
    name: "हिन्दी",
    region: "भारत",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/hi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    region: "Deutschland",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "Nederlands",
    region: "Nederland",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Português",
    region: "Portugal",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italiano",
    region: "Italia",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    name: "日本語",
    region: "日本",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/ja.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    name: "한국어",
    region: "대한민국",
    files: [
      {
        path: "/home/vsts/work/1/s/webapp-ots-nuxt/i18n/locales/ko.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/